import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { applyPortal, portalForRoute } from "@/lib/pwa";

// Renders nothing — keeps <head>'s manifest link in step with the current route
// (and signed-in role) so Add to Home Screen installs the right portal.
export default function PwaManifest() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const role = user ? user.role : null;

  useEffect(() => {
    applyPortal(portalForRoute(pathname, role));
  }, [pathname, role]);

  return null;
}
